module.exports = __webpack_public_path__ + "img/car_rear_right.c01cf889.svg";